var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadVue'),_c('router-view'),_c('FooterVue',{attrs:{"address":_vm.address,"siteID":_vm.siteID,"siteName":_vm.siteName,"siteIDs":_vm.siteIDs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }